import Service from "../../AuthService";
const RateBonusSale = {
    getRateBonusSale(page) {
        return Service.get("/rate_bonus_sale?page="+page);
    },
    showRateBonusSale(id) {
        return Service.get("/rate_bonus_sale/" + id);
    },
    updateRateBonusSale(id, data) {
        return Service.put("/rate_bonus_sale/" + id, data);
    },
    createRateBonusSale(data) {
        return Service.post("/rate_bonus_sale", data);
    },
    deleteRateBonusSale(id) {
        return Service.delete("/rate_bonus_sale/" + id);
    },
    searchRateBonusSale(data){
        return Service.post("/rate_bonus_sale_search",data)
    }
};
export default RateBonusSale;
